<div class="container-fluid">
  <h1 mat-dialog-title i18n>Import Item Quantity</h1>
  <div *ngIf="!fileSelected" mat-dialog-content>
    <h5 class="mt-5" i18n>Select a file then Click "Import File" to import item source data.</h5>
    <form #importForm="ngForm" (ngSubmit)="importItem()" class="container">
      <div class="form-group row">
        <div class="col-sm-12 form-inline">
          <div class="control-wrapper">
            <label for="workOrderSqrFt" i18n>File:</label>
            <app-file-upload [(fileBytes)]="fileBytes" [(importFile)]="importFile"
                             accept=".csv, .xlsx, text/csv, application/openxmlformats-officedocument.spreadsheetml.sheet"></app-file-upload>
          </div>
          <div *ngIf="errors" class="mt-3 alert alert-danger">
            {{ errors }}
          </div>
        </div>
      </div>
      <div *ngIf="!isRequesting">
        <button type="submit" mat-button class="btn btn-bidit-action mr-1" i18n>Import File</button>
        <button type="button" mat-button (click)="onNoClick()" class="btn btn-bidit-cancel" i18n>Cancel</button>
      </div>
      <app-spinner [isRunning]="isRequesting"></app-spinner>
    </form>
  </div>

  <div *ngIf="this.importComplete" class="card bg-light">
    <div class="card-body">
      <img src="assets/img/circle_images/customer_circle.png" alt="Customer Icon" class="card-icon" />
      <h5 i18n>Item Import - Failures</h5>
      <button type="button" (click)="exportErrors()" mat-button class="float-end btn btn-bidit-action mr-1" i18n>Export</button>

      <h6 class="mt-5" i18n>Review the failed import data below.  To make corrections click 'Export' make changes and re-import</h6>
      <mat-table class="table table-bidit table-striped" style="width: 100%;" [dataSource]="dataSource">
        <ng-container matColumnDef="itemName">
          <mat-header-cell *matHeaderCellDef class="bidit-header" i18n>Item Description</mat-header-cell>
          <mat-cell *matCellDef="let itemImport">
            {{itemImport.itemImport_Item_Name}}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="itemSalesDesc">
          <mat-header-cell *matHeaderCellDef class="bidit-header" i18n>Item Description</mat-header-cell>
          <mat-cell *matCellDef="let itemImport">
            {{itemImport.ItemImport_Sales_Desc}}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="rValue">
          <mat-header-cell *matHeaderCellDef class="bidit-header" i18n>R-Value</mat-header-cell>
          <mat-cell *matCellDef="let itemImport">
            <div fxLayout="column">
              <div>
                {{itemImport.ItemImport_RValue_Desc}}
              </div>
            </div>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="itemTypeDesc">
          <mat-header-cell *matHeaderCellDef class="bidit-header" i18n>Item Type</mat-header-cell>
          <mat-cell *matCellDef="let itemImport">
            <div fxLayout="column">
              {{itemImport.ItemImport_ItemType_Desc}}
            </div>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="cost">
          <mat-header-cell *matHeaderCellDef class="bidit-header" i18n>Cost</mat-header-cell>
          <mat-cell *matCellDef="let itemImport">
            <div fxLayout="column">
              <div *ngIf="itemImport.itemImport_Cost">
                {{itemImport.itemImport_Cost}}
              </div>
            </div>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="sqrFtPerUnit">
          <mat-header-cell *matHeaderCellDef class="bidit-header" i18n>Sqr Ft Per Unit</mat-header-cell>
          <mat-cell *matCellDef="let itemImport">
            <div fxLayout="column">
              <div *ngIf="itemImport.ItemImport_SqrFtPerUnit">
                {{itemImport.ItemImport_SqrFtPerUnit}}
              </div>
            </div>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="costPerSqrFt">
          <mat-header-cell *matHeaderCellDef class="bidit-header" i18n>Cost Per SqrFt</mat-header-cell>
          <mat-cell *matCellDef="let itemImport">
            <div fxLayout="column">
              <div *ngIf="itemImport.ItemImport_CostPerSqrFt">
                {{itemImport.ItemImport_CostPerSqrFt}}
              </div>
            </div>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="costPerSqrFtOverage">
          <mat-header-cell *matHeaderCellDef class="bidit-header" i18n>Cost Per SqrFt Overrage</mat-header-cell>
          <mat-cell *matCellDef="let itemImport">
            <div fxLayout="column">
              <div *ngIf="itemImport.ItemImport_CostSqrFtOverage">
                {{itemImport.ItemImport_CostSqrFtOverage}}
              </div>
            </div>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="sqrFtUptoOverage">
          <mat-header-cell *matHeaderCellDef class="bidit-header" i18n>SqrFt Upto Overrage</mat-header-cell>
          <mat-cell *matCellDef="let itemImport">
            <div fxLayout="column">
              <div *ngIf="itemImport.ItemImport_SqrFt_UptoOverage">
                {{itemImport.ItemImport_SqrFt_UptoOverage}}
              </div>
            </div>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="origMfgPart">
          <mat-header-cell *matHeaderCellDef class="bidit-header" i18n>Orig Mfr Part#</mat-header-cell>
          <mat-cell *matCellDef="let itemImport">
            <div fxLayout="column">
              <div *ngIf="itemImport.itemImport_Item_Part">
                {{itemImport.itemImport_Item_Part}}
              </div>
            </div>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="mfrPart">
          <mat-header-cell *matHeaderCellDef class="bidit-header" i18n>Mfr Part#</mat-header-cell>
          <mat-cell *matCellDef="let itemImport">
            <div fxLayout="column">
              <div *ngIf="itemImport.ItemImport_ExternalItemPart">
                {{itemImport.ItemImport_ExternalItemPart}}
              </div>
            </div>
          </mat-cell>
        </ng-container>        
        <ng-container matColumnDef="itemMessage">
          <mat-header-cell *matHeaderCellDef class="bidit-header" i18n>Error</mat-header-cell>
          <mat-cell *matCellDef="let itemImport">
            <div fxLayout="column">
              <div *ngIf="itemImport.itemImport_Message">
                {{itemImport.itemImport_Message}}
              </div>
            </div>
          </mat-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="displayedColumns">
        </mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>

      </mat-table>
    </div>
  </div>
</div>
